import { memo } from "react";
import { getIntroTheme } from "@/lib/seasonalIntro";

const video = getIntroTheme().video;

/**
 * Vídeo de marca aislado y memoizado para que los re-renderizados
 * del formulario de login no provoquen pestañeos / remount del <video>.
 */
const LoginBrandVideo = memo(function LoginBrandVideo() {
  return (
    <div
      className="w-96 md:w-[28rem] pointer-events-none select-none"
      translate="no"
      suppressHydrationWarning
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      style={{
        WebkitMaskImage:
          "radial-gradient(ellipse at center, black 80%, transparent 100%)",
        maskImage:
          "radial-gradient(ellipse at center, black 80%, transparent 100%)",
        // Aislar capa de composición para evitar repaints del mask con cada render
        transform: "translateZ(0)",
        willChange: "transform",
        backfaceVisibility: "hidden",
      }}
    >
      <video
        src={video}
        autoPlay
        muted
        playsInline
        preload="auto"
        draggable={false}
        className="w-full object-contain pointer-events-none select-none"
        onEnded={(e) => {
          // Congela el último frame sin re-iniciar el vídeo
          e.currentTarget.pause();
        }}
        onContextMenu={(e) => e.preventDefault()}
        controlsList="nodownload nofullscreen noremoteplayback"
        disablePictureInPicture
        disableRemotePlayback
      />
    </div>
  );
});

export default LoginBrandVideo;
